import styles from "./styles.module.scss";

import WindowsIcon from "assets/icons/windows.svg?react";
import MacIcon from "assets/icons/mac.svg?react";
import { useTranslation } from "react-i18next";

export const BodyPluginUpdate = ({
  isWindows,
  isMac,
  linkWindows,
  linkMac,
  title,
  hint,
}: {
  isWindows: boolean;
  isMac: boolean;
  linkWindows: string;
  linkMac: string;
  className?: string;
  title?: string;
  hint?: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.window} `}>
      <div className={styles.wrapper}>
        <div className={styles.title}>
          {title ?? t("plugin.updatePlugin")}
          <div className={styles.bar}></div>
        </div>
        <div className={styles.body}>{hint ?? t("plugin.updateDescription")}</div>

        <div className={styles.system}>
          {!isMac && (
            <a rel="noreferrer" target="_blank" href={linkWindows}>
              <div className={styles.box}>
                <WindowsIcon />
                Windows
              </div>
            </a>
          )}
          {!isMac && !isWindows && <div className={styles.line}></div>}
          {!isWindows && (
            <a rel="noreferrer" target="_blank" href={linkMac}>
              <div className={styles.box}>
                <MacIcon />
                MacOS
              </div>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
